import { gql } from '@apollo/client';

export const MARKETPLACE_LEADS_CSV = gql`
  query ($marketplaceMetricsRequest: MarketplaceMetricsRequest!) {
    getMarketplaceLeadsCsv(input: $marketplaceMetricsRequest)
  }
`;
